import { useState, useEffect } from "react";
import { BsEyeSlash } from "react-icons/bs";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Popup from "../../../../components/popup/Popup";
import { CSS_CLASSES } from "../../../../css-classes";
import {
  showMessage,
  makeAjax,
  url,
  respStatus,
  alternativeSiteOperation,
} from "../../../../helpers/global_helper";
import { BiShowAlt } from "react-icons/bi";
import { FaRegUser } from "react-icons/fa";
import { MdLockOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { FloatingLabel } from "react-bootstrap";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import {
  getPlayerProfileDetail,
  resetPlayerProfile,
} from "../../../../store/actions";
import {
  checkPinStatus,
  resetPinStatus,
} from "../../../../store/check-pin-status/actions";
import ActionLoader from "../../../../pages/ActionLoader";
import LanguageDropdown from "../../../../components/languageDropdown/LanguageDropdown";
import ErrorBoundary from "../../../../helpers/ExceptionHandler/componentException";

const initSetting = {
  login_modal: null,
  register_modal: null,
  default_class: null,
  default_register_class: null,
};

const UserLogin = (props) => {
  const [fnSetting, setFnSetting] = useState(initSetting);
  const [fnSettingR, setFnSettingR] = useState(initSetting);
  const [globalMaintenance, setGlobalMaintenance] = useState(false);
  const [isPopup, setIsPopup] = useState(false);
  const [isLoginPopup, setIsLoginPopup] = useState(false);
  const [inputType, setInputType] = useState("password");
  const [loaderStatus, setLoader] = useState(false);
  const [userDataHandleClick, setUserDataHandleClick] = useState(false);
  const [formError, setFormError] = useState({});
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const [showRegisterpopup, setShowRegisterpopup] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    key: ""
  });

  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlePopup = () => {
    setIsPopup(false);
    setGlobalMaintenance(false);
    setIsLoginPopup(false);
  };

  const userDataHandle = () => {
    setUserDataHandleClick(true);
  };

  const HandleRegisterPopup = () => {
    setShowRegisterpopup(!showRegisterpopup);
  };

  const fieldChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setFormData((values) => ({ ...values, [name]: value }));
    setErrors((values) => ({ ...values, [name]: null }));
  };

  const { pinStatus, playerMenu } = useSelector((state) => ({
    pinStatus: state.checkPinStatusR?.data ?? {},
    playerMenu: state.menuListR.data,
  }));

  const redirectMe = (pinStatus, path, component_location) => {
    if (Object.keys(pinStatus).length) {
      let config_status = pinStatus.get_tenant_config?.value;
      if (
        config_status === true &&
        pinStatus.enabled_active_pin === true &&
        pinStatus.active_pin === false
      ) {
        navigate("/login-pin");
        return;
      } else if (
        config_status === true &&
        pinStatus.enabled_active_pin === true &&
        pinStatus.is_pin_verified === false
      ) {
        navigate("/security-validation");
        return;
      } else if (
        pinStatus.is_security_question_set === false ||
        pinStatus.is_security_question_set === null
      ) {
        navigate("/security-question");
        return;
      } else if (pinStatus.is_password_active === false) {
        navigate("/reminder-password");
        return;
      } else {
        dispatch(getPlayerProfileDetail());
        navigate("/");
        return;
      }
    }
  };

  useEffect(() => {
    redirectMe(pinStatus, location.pathname, "/");
  }, [pinStatus]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoader(true);
      localStorage.removeItem("user_token");
      localStorage.removeItem("isLoggedIn");
      const response = await makeAjax(url.USER_API.login, formData, url.USER_MS_EXT);
      if (response.status !== respStatus["SUCCESS"]) {
        setLoader(false);
        if (response.code == "loginMaintenanceOn") {
          let msg = response.messages[0];
          if (response.data) {
            msg = response.data;
          }
          setGlobalMaintenance(msg);
          return;
        }
        if (response.code !== "validation_error") {
          showMessage(response);
        }
        setFormError(response.messages);
        return;
      }
      let my_token = response.data.token;
      await Promise.resolve().then(() => {
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("user_token", my_token);
      });
      setTimeout(() => {
        let ret = alternativeSiteOperation('is_login');
        if (!ret) {
          dispatch(checkPinStatus());
          dispatch(getPlayerProfileDetail());
          if (['/register'].includes(location.pathname))
            navigate("/");
          setLoader(false);
        }
      }, 200);
    } catch (error) {
      console.error(error);
      setLoader(false);
      showMessage({ messages: ["Something went wrong. Please try again."] });
    }
  };
  // Show password
  const showPassword = (event) => {
    if (inputType == "password") setInputType("text");
    if (inputType == "text") setInputType("password");
  };

  useEffect(() => {
    dispatch(resetPlayerProfile());
    dispatch(resetPinStatus());
  }, []);

  useEffect(() => {
    let tmp = fnSetting;
    if (typeof componentSetting?.["top-nav-login-box"] != "undefined") {
      tmp["login_modal"] =
        componentSetting?.["top-nav-login-box"]?.["default-value"];
    }

    if (typeof componentSetting?.["top-nav-register-box"] != "undefined") {
      tmp["register_modal"] =
        componentSetting?.["top-nav-register-box"]?.["default-value"];
    }
    setFnSetting(tmp);

  }, [componentSetting]);

  return (
    <>
      <div className="user-login-sec">
        <div>
          {fnSetting["login_modal"] && (
            <div className={CSS_CLASSES.userLoginBox}>
              <div className={fnSetting["login_modal"]}>
                {fnSetting["login_modal"] == "inline" && (
                  <form className="user-login-form">
                    {errors.messages ? (
                      <div color="danger">{errors.messages[0]}</div>
                    ) : null}

                    <FloatingLabel
                      controlId="floatingInput"
                      label="username"
                      className="field"
                    >
                      <FaRegUser className="user-icon" />
                      <Form.Control
                        type="text"
                        placeholder={props.t("username")}
                        name="username"
                        value={formData.username}
                        onChange={fieldChange}
                      />
                      <span
                        className="forget-password"
                        onClick={() => setIsPopup((curr) => !curr)}
                      >
                        {props.t("customer_complaints")}
                      </span>
                      {formError.username ? (
                        <span className="text-danger">
                          {formError.username[0]}
                        </span>
                      ) : null}
                    </FloatingLabel>

                    <FloatingLabel
                      controlId="floatingPassword"
                      label={props.t("password")}
                      className="field"
                    >
                      <MdLockOutline className="user-icon2" />
                      <Form.Control
                        type={inputType}
                        placeholder={props.t("password")}
                        name="password"
                        value={formData.password}
                        onChange={fieldChange}
                      />
                      {inputType == "password" && (
                        <BsEyeSlash
                          className="icon"
                          onMouseEnter={showPassword}
                        />
                      )}
                      {inputType == "text" && (
                        <BiShowAlt
                          className="icon"
                          onMouseLeave={showPassword}
                        />
                      )}
                      <NavLink
                        to={"forgot-password"}
                        className="forget-password"
                      >
                        {props.t("forget_password")}?
                      </NavLink>
                      {formError.password ? (
                        <span className="text-danger">
                          {formError.password[0]}
                        </span>
                      ) : null}
                    </FloatingLabel>

                    <ErrorBoundary>
                      <ActionLoader
                        label={"login"}
                        loaderClass={"login-loader"}
                        showLoader={loaderStatus}
                        onClick={handleSubmit}
                      />
                    </ErrorBoundary>
                  </form>
                )}
                {fnSetting["login_modal"] == "popup" && (
                  <form className="user-login-form">
                    {errors.messages ? (
                      <div color="danger">{errors.messages[0]}</div>
                    ) : null}

                    <Link
                      className="login-wrapbtn text_button-login border-login background-login_button"
                      onClick={() => setIsLoginPopup(true)}
                    >
                      {props.t("login")}
                    </Link>
                  </form>
                )}
              </div>
            </div>
          )}
        </div>

        <div>
          {fnSettingR["register_modal"] && (
            <div className={CSS_CLASSES.userLoginBox}>
              <div className={fnSettingR["register_modal"]}>
                {fnSettingR["register_modal"] == "inline" && (
                  <form className="user-login-form">
                    {errors.messages ? (
                      <div color="danger">{errors.messages[0]}</div>
                    ) : null}
                    {/* {playerMenu.before &&
                      playerMenu.before.register &&
                      playerMenu.before.register.status ? (
                      <div className="reg-btn">
                        <NavLink to={"register"} className="register">
                          {props.t(`${playerMenu.before.register.code}`)}
                        </NavLink>
                      </div>
                    ) : null} */}
                    <NavLink to="register" className="register text_button-register border-register background-register_button 22222">
                      {props.t("register")}
                    </NavLink>
                  </form>
                )}

                {fnSettingR["register_modal"] == "popup" && (
                  <form className="user-login-form">
                    {errors.messages ? (
                      <div color="danger">{errors.messages[0]}</div>
                    ) : null}

                    {/* {playerMenu.before &&
                    playerMenu.before.register &&
                    playerMenu.before.register.status ? (
                      <div className="reg-btn">
                        <NavLink
                          className="register"
                          onClick={HandleRegisterPopup}
                        >
                          {props.t(`${playerMenu.before.register.code}`)}
                        </NavLink>
                      </div>
                    ) : null} */}
                    <div className="reg-btn">
                      <NavLink
                        className="register"
                        onClick={HandleRegisterPopup}
                      >
                        {props.t("register")}
                      </NavLink>
                    </div>
                  </form>
                )}
              </div>
            </div>
          )}
        </div>
        <div>
          <ErrorBoundary>
            <LanguageDropdown />
          </ErrorBoundary>
        </div>
      </div>

      {showRegisterpopup && (
        <div className="register-popup">
          <Popup
            handlePoup={HandleRegisterPopup}
            registerpopup
            userDataHandle={userDataHandle}
          />
        </div>
      )}

      {isLoginPopup && (
        <Popup
          handlePoup={handlePopup}
          loginpopup
          userDataHandle={userDataHandle}
        />
      )}

      {isPopup && <Popup handlePoup={handlePopup} custComplaint />}

      {globalMaintenance && (
        <Popup
          handlePoup={handlePopup}
          globalMaintenanceCondition
          message={globalMaintenance}
        />
      )}
    </>
  );
};

UserLogin.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(UserLogin);
